import ScrollToTop from "../../components/ScrollToTop.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import HiperLigFiberHeroComponent from "../../components/hero/hiperligfiber/HiperLigFiberHeroComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";
import {Link} from "react-router-dom";
import QuestionAnswerComponent, {Question} from "../../components/help/QuestionAnswerComponent.tsx";
import {ALL_FIBER} from "../../components/coverageMap/CoverageMap.ts";
import useDatalayer from "../../components/useDatalayer.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import Routing from "../../Routing.ts";
import CoverageMapContainer from "../../components/coverageMap/CoverageMapContainer.tsx";

const questions: Question[] = [
    {
        question: 'Kan jeg få fibernet på min adresse?',
        answer: <>
            <p>
                Du kan få en fiberforbindelse, hvis der er gravet fiberkabler ned i jorden nær din bopæl, eller hvis du allerede har en fiberboks etableret.
            </p>
            <p>
                Du kan tjekke, hvorvidt du kan få fiber bredbånd installeret i din bolig.
            </p>
            <p>
                <button
                    className={'link'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >Tjek din adresse her</button>
            </p>
        </>,
    },
    {
        question: 'Hvad betyder 1000/1000 Mbit internet?',
        answer: <>
            <p>
                1000/1000 Mbit internet betyder, at din internetforbindelse har en download-hastighed på 1000 megabit per sekund (Mbit/s) og en upload-hastighed på 1000 megabit per sekund (Mbit/s).
                1000 Mbit internet er den hurtigste hastighed, vi kan levere og også den mest optimale, hvis du har mange enheder på dit wifi samtidig.
                Du kan godt købe 1000/1000 Mbit fibernet hos os, men vi leverer også andre hastigheder.
            </p>
            <p>
                Du kan læse mere om download- og upload-hastighed i vores <Link to="/hjaelp/internet-og-wifi/hastighedstest">hastighedstest-artikel</Link>.
            </p>
        </>,
    },
    {
        question: 'Skal jeg have en tekniker på besøg?',
        answer: <>
            <p>
                Når du indtaster din adresse og vælger et fiberprodukt, kan du se, om du skal have en tekniker på besøg.
                Det afhænger nemlig af din fiberinstallation &ndash; nogle gange mangler der en fiberboks, og andre gange skal den eksisterende fiberboks udskiftes.
            </p>
            <p>
                Læs mere om <Link to="/hjaelp/bestilling/fiber-installation">fiberinstallation her</Link>.
            </p>
        </>,
    },
    {
        question: 'Hvad koster fibernet?',
        answer: <>
            <p>
                Hos Hiper har vi ofte billige fibernet priser.
                Priserne varierer afhængigt af, hvilken infrastruktur der ligger i vejen, og det er derfor adressespecifikt hvilket tilbud, som du kan få.
                Du kan som udgangspunkt få fiber bredbånd fra kun 279,- om måneden.
                Hvis du skal have installeret fiber på din adresse, kan det koste 699,- for en standard <Link to="/hjaelp/bestilling/fiber-installation">fiberinstallation.</Link> Vi har dog ofte fibernet-kampagner hvor at fiberinstallationsprisen bliver dækket af os, så vi råder altid til at du laver et adresseopslag for at se dine muligheder.
                Hvis du allerede har en fiberboks installeret i din bolig, skal du blot betale for abonnementsprisen.
            </p>
            <p>
                <button
                    className={'link'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >Søg på din adresse</button> og se, hvilket specifikt tilbud og pris, som vi kan tilbyde dig, så du kan få billigt fibernet.
            </p>
        </>,
    },
    {
        question: 'Hvor mange enheder kan jeg koble til mit fibernet bredbånd?',
        answer: <p>
            Med 1000 Mbit fibernet behøver du ikke bekymre dig om, om der er nok båndbredde til alle dine enheder &ndash; og dine gæsters enheder.
            Du kan koble lige så mange enheder på din 1000 Mbit fiberforbindelse, som du har lyst til.
        </p>,
    },
    {
        question: 'Hvad er forskellen på fibernet og andre typer internetforbindelser?',
        answer: <p>
            Forskellen på fibernet vs. <Link to={Routing.Broadband.TDC5G}>5G-internet</Link> og <Link to={Routing.Broadband.Coax}>coax internet</Link> ligger hovedsageligt i teknologien, hastigheden og prisen.
            Vil du sammenligne de forskellige internetforbindelser, kan du læse <Link to="/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge">denne artikel</Link>.
        </p>,
    },
    {
        question: 'Skal jeg selv opsige min nuværende bredbåndsaftale hos en anden udbyder?',
        answer: <>
            <p>
                Vi kan opsige dit nuværende internet abonnement for dig.
                Når du bestiller Hiper internet, kan du udfylde en fuldmagt, der giver os lov til at opsige dit nuværende abonnement for dig.
                Du behøver hverken MitID eller at printe den ud.
                Vi præsenterer fuldmagten for dig efter du har bestilt, så du selv kan vælge, om vi skal klare opsigelsen eller ej &ndash; nemmere bliver det ikke.
            </p>
            <p>
                Hvis du ikke udfylder fuldmagten i forbindelse med bestillingen, får du også en mail med mere information.
            </p>
        </>,
    },
    {
        question: 'Kan jeg ændre min hastighed?',
        answer: <>
            <p>
                Du kan altid opgradere din hastighed &ndash; til f.eks. 1000 Mbit fibernet.
                Læs mere om, hvordan du opgraderer din forbindelse <Link to="/hjaelp/mit-abonnement/skift-hastighed">her</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg teste min hastighed?',
        answer: <>
            <p>
                Ja, vi har gjort det nemt for dig at tage en hastighedstest.
                Se hvordan du gør det <Link to="/hjaelp/internet-og-wifi/hastighedstest">her</Link>.
            </p>
            <p>
                Husk at når du installerer dit internet, er <Link to="/hjaelp/internet-og-wifi/placering-af-router">placeringen af din router</Link> og hvad dine enheder kan trække, meget afgørende for din internethastighed.
                Læs mere om det <Link to="/hjaelp/internet-og-wifi/hvordan-traekker-jeg-1000-mbit">her</Link>.
            </p>
        </>,
    },
    {
        question: 'Hvor lang er min bindingsperiode?',
        answer: <p>
            Der er 6 måneders binding på dit Hiper bredbånd, som gælder fra leveringsdatoen.
            Hvis du vælger at opsige dit abonnement, får du en bekræftelse i en mail, hvor du kan se den præcise slutdato for abonnementet, og hvordan du skal returnere det fremsendte udstyr.
        </p>,
    },
    {
        question: 'Kan jeg bruge mit eget udstyr?',
        answer: <>
            <p>
                Ja, du er altid velkommen til at bruge dit eget udstyr.
            </p>
            <p>
                Læs mere <Link to="/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr">her</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg få en fast IP-adresse?',
        answer: <>
            <p>
                Du kan få en fast IP-adresse til 19 kr./md. eller en gratis dynamisk IP-adresse.
            </p>
            <p>
                Læs mere <Link to="/hjaelp/internet-og-wifi/ip-adresse">her</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg få tv-pakker hos Hiper?',
        answer: <p>
            Nej, vi sælger kun internet.
            Det betyder, at vi hverken har TV-pakker eller andre streamingtjenester inkluderet i vores bredbåndsløsninger.
            Med det sagt, så kan du godt bruge vores lynhurtige internet til streaming på alle streamingtjenester, hvor du skulle have et abonnement.
        </p>,
    },
    {
        question: 'Har I mobilabonnementer eller mobilt bredbånd?',
        answer: <p>
            Vi har mobilt bredbånd, men vi sælger ikke mobilabonnementer.
            Hvis du køber 5G-internet hos Hiper, får du Danmarks bedste 5G-dækning.
            Læs mere om <Link to={Routing.Broadband.TDC5G}>vores 5G-internet her</Link>.
        </p>,
    },
]

export default function FiberPage() {
    ScrollToTop()
    useDatalayer()
    setTitleAndMetaDescription(
        'Fibernet fra 99,-/md. | 100 eller 1000 Mbit lynhurtig fiber',
        'Hiper har stabilt og billigt fiber internet, som alle kan streame på samtidigt. Tjek fibernet på din adresse og få din fiberforbindelse til en god pris.'
    )

    return (
        <div className={"page-products-fiber"}>
            <HiperLigFiberHeroComponent/>

            <section className="section-lightgrey section-reasons">
                <div className="content content--medium">
                    <div className="blurb">
                        <h2 className="heading heading--big">3 fordele ved at vælge en fiberforbindelse:</h2>
                    </div>
                    <ul className="grid grid-triple-with-icons grid-triple-with-count">
                        <li>
                            <h3 className="heading heading--medium heading--montserrat">Lynhurtig streaming</h3>
                            <p>
                                Stream nemt alle dine yndlingsserier og film direkte på TV-skærmen via Chromecast, Apple TV eller Smart TV &ndash; helt uden forsinkelser med en fiberforbindelse.
                                Bedst af alt, så kan hele familien gøre det på samme tid fra forskellige enheder.
                            </p>
                        </li>
                        <li>
                            <h3 className="heading heading--medium heading--montserrat">Optimalt til gaming</h3>
                            <p>
                                Slut med langsomme reaktionstider.
                                Med fibernet bliver data sendt lynhurtigt frem og tilbage, så du får en ping latency i den lave ende.
                                Derfor får du altid den mest optimale gaming oplevelse med fibernet.
                            </p>
                        </li>
                        <li>
                            <h3 className="heading heading--medium heading--montserrat">Meget stabilt</h3>
                            <p>
                                Fibernet benytter lyslederkabler for høj stabilitet og hastighed og kan trække 1000 Mbit på kabelforbindelsen.
                                Det betyder, at der ikke opstår forsinkelse på fiberforbindelsen, og du er sikret en høj download- og upload-hastighed på dit internet.
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="section-white section-includes">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big">Det får du med i dit fiber internet abonnement</h2>
                    </div>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <img
                                src={imageMap.products.router_fiber2}
                                alt="Du får en Zyxel router, når du køber det bedste fibernet hos Hiper. Den tilkobler du din fiberboks."
                            />
                        </li>
                        <li>
                            <h3 className="heading heading--paragraph heading--small heading--left"><strong>Fibernet router følger med</strong></h3>
                            <p>
                                Bestiller du fibernet fra Hiper får du en af markedets nyeste og bedste router til fibernet fra Zyxel med i dit abonnement, som sikrer dig lynhurtigt internet.
                                Med fiber-routeren kan du selv vælge, om du vil benytte wifi i din bolig, eller om du ønsker en kablet LAN-forbindelse.
                            </p>
                            <p>
                                <Link to="/hjaelp/udstyr/hvilken-router-foelger-med">Læs mere om routeren</Link>
                            </p>
                        </li>
                    </ul>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <img
                                src={imageMap.products.mit_hiper}
                                alt="Når du køber fiber hos Hiper, får du adgang til Mit Hiper selvbetjening, hvor du kan tilgå alt vedrørende dit fiber bredbånd."
                            />
                        </li>
                        <li>
                            <h3 className="heading heading--paragraph heading--small heading--left"><strong>Adgang til egen selvbetjening</strong>
                            </h3>
                            <p>
                                Når du bestiller et fibernet abonnement hos Hiper, så får du adgang til din egen selvbetjening, Mit Hiper, hvor du kan finde dine regninger, skifte betalingskort m.m..
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="section-white">
                <div className="content content--medium">
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <div className="blurb">
                                <h2 className="heading heading--medium heading--left">Hvad er fibernet?</h2>
                            </div>
                            <p>
                                Fibernet, også kaldet &ldquo;fiber&rdquo;, benytter lyslederkabler og er kendt for høj stabilitet og høje hastigheder.
                                Med en internetforbindelse via fiber bredbånd er der minimal forsinkelse af den data, du sender eller modtager.
                                Hvis du har en 1000 Mbit fibernetforbindelse, kan dit fiberkabel rumme nok data til, at flere tv, computere og smartphones kan bruge data på samme tid.
                            </p>
                            <Link to="/hjaelp/bestilling/fiber-installation">Se mere om fiberinstallation</Link>
                        </li>
                        <li>
                            <div className="blurb">
                                <h2 className="heading heading--medium heading--left">Lynhurtig fiberforbindelse</h2>
                            </div>
                            <p>
                                Fibernet er det bedste og mest stabile internet, man kan få, da fiberoptiske kabler er meget mindre påvirket af elektrisk &ldquo;støj&rdquo;, vejrforhold eller overbelastning på netværket end andre internetforbindelser.
                                Med fiber internet er du sikret en af de højeste hastigheder, som markedet kan tilbyde på download og upload.
                                Fiberforbindelsen er perfekt til dig, som gerne vil sikre dig den allerbedste og stabile oplevelse med streaming, live-tv uden afbrydelser og <Link to="/hjaelp/bestilling/internet-til-gaming">gaming</Link> uden lag spikes.
                            </p>
                            <Link to={Routing.Broadband.Index}>Se fibernet priser</Link>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="section-white">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big">Værd at vide om fibernet</h2>
                    </div>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </section>

            <section className="section-white section-coverage">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big">Fibernet dækningskort i Danmark</h2>
                    </div>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <p>
                                Vi har aftaler med langt de fleste fiber-leverandører i Danmark og kan derfor nu tilbyde fibernet i størstedelen af landet &ndash; til en knivskarp pris.
                                Er du i tvivl, om du kan få billigt fibernet, kan du indtaste din adresse og få direkte besked.
                            </p>

                            <h3 className="heading heading--paragraph heading--small heading--left"><strong>Se hvilke områder vi dækker</strong></h3>
                            <p>
                                Brug knapperne over kortet til at vælge de specifikke fiber-netværker, og se om dit lokalområde er dækket.
                                Fiberområderne er markerede med rød.
                            </p>

                            <h3 className="heading heading--paragraph heading--small heading--left"><strong>Fiber er fremtiden</strong></h3>
                            <p>
                                Fiber bredbånd er en fremtidssikring af dit internet, da vi bruger mere og mere data og samtidig får flere enheder koblet til nettet.
                                Hvis dit område ikke står på dækningskortet og fibernet ikke er tilgængeligt på din adresse endnu, så hold øje med vores hjemmeside, da vi løbende udvider vores fiber dækning.
                            </p>
                            <button
                                className={'link'}
                                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                            >Bestil din fiberforbindelse her.</button>
                        </li>
                        <li>
                            <CoverageMapContainer regionPreset={ALL_FIBER} fiberMapOnly={true} static={false}/>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    )
}
